import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { ClienteTipoDTO, ClienteSubTipoDTO, RelacionViewDTO, RelacionItemDTO } from './types'

const getEndpoint = (url = '') => `operacion-lcls${url}`

export const HttpClienteTipo = {
    getAll: (): Promise<ClienteTipoDTO[]> =>
        HttpAxiosRequest.get(getEndpoint('/cliente-tipo')),

    insert: (data: { vchDescClienteTipo: string }): Promise<any> =>
        HttpAxiosRequest.post(getEndpoint('/cliente-tipo'), { descripcion: data.vchDescClienteTipo }),

    update: (id: number, data: { vchDescClienteTipo: string }): Promise<any> =>
        HttpAxiosRequest.put(getEndpoint(`/cliente-tipo/${id}`), { descripcion: data.vchDescClienteTipo }),

    deactivate: (id: number): Promise<any> =>
        HttpAxiosRequest.delete(getEndpoint(`/cliente-tipo/${id}`))
}

export const HttpClienteSubTipo = {
    getAll: (): Promise<ClienteSubTipoDTO[]> =>
        HttpAxiosRequest.get(getEndpoint('/cliente-subtipo')),

    insert: (data: { vchDescClienteSubTipo: string }): Promise<any> =>
        HttpAxiosRequest.post(getEndpoint('/cliente-subtipo'), { descripcion: data.vchDescClienteSubTipo }),

    update: (id: number, data: { vchDescClienteSubTipo: string }): Promise<any> =>
        HttpAxiosRequest.put(getEndpoint(`/cliente-subtipo/${id}`), { descripcion: data.vchDescClienteSubTipo }),

    deactivate: (id: number): Promise<any> =>
        HttpAxiosRequest.delete(getEndpoint(`/cliente-subtipo/${id}`))
}

export const HttpLCLSRelacion = {
    getBySector: (codSectorComercial: number): Promise<RelacionViewDTO[]> =>
        HttpAxiosRequest.get(getEndpoint(`/relacion/${codSectorComercial}`)),

    update: (codSectorComercial: number, relaciones: RelacionItemDTO[]): Promise<any> =>
        HttpAxiosRequest.post(getEndpoint(`/relacion/${codSectorComercial}`), relaciones)
}
